module.exports = __webpack_public_path__ + "qa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/qa.svg
// module id = 776
// module chunks = 0